"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROD_URL = exports.NON_PROD_URL = void 0;
exports.default = createApmClient;
var _apmRum = require("@elastic/apm-rum");
var _apmRumCore = require("@elastic/apm-rum-core");
var _isProd = _interopRequireDefault(require("./isProd"));
// Export for testing
var PROD_URL = exports.PROD_URL = 'https://e7045f31a4fa441f8ea59847a670aca1.apm.us-west-2.aws.found.io:9243/';
var NON_PROD_URL = exports.NON_PROD_URL = 'https://0c382ace64564072bae00d6ec9f478b5.apm.us-west-2.aws.found.io:9243/';
function getEnvironment(rootDomain) {
  if ((0, _isProd.default)(rootDomain)) {
    return 'prod';
  }

  // If we are not in production then the first section should be the environment (e.g. dev, test)
  var domainSections = rootDomain.split('-');
  return domainSections[0];
}
function createApmClient(namespace, rootDomain) {
  var environment = getEnvironment(rootDomain);
  var serverUrl = (0, _isProd.default)(rootDomain) ? PROD_URL : NON_PROD_URL;

  // HACK The APM client is a singleton.  To avoid that we have to use an undocumented method to
  // create a new client.
  var enabled = (0, _apmRumCore.bootstrap)();
  var serviceFactory = (0, _apmRumCore.createServiceFactory)();
  var apmBase = new _apmRum.ApmBase(serviceFactory, !enabled);
  var apmClient = apmBase.init({
    serviceName: namespace,
    environment: environment,
    serverUrl: serverUrl,
    instrument: false
  });
  return apmClient;
}